/**
 * IRPF progressive monthly table constants.
 * @see https://www.gov.br/receitafederal/pt-br/assuntos/meu-imposto-de-renda/tabelas/tabela-progressiva-mensal
 */

export const IRPF_TABELAS_URL =
  'https://www.gov.br/receitafederal/pt-br/assuntos/meu-imposto-de-renda/tabelas';

export const IRPF_TABELA_PROGRESSIVA_MENSAL_URL =
  'https://www.gov.br/receitafederal/pt-br/assuntos/meu-imposto-de-renda/tabelas/tabela-progressiva-mensal';

export const LEI_7713_URL = 'https://www.planalto.gov.br/ccivil_03/leis/l7713.htm';

export const IRPF_DEFAULT_ANO = 2025;

export const IRPF_FAIXAS_POR_TABELA = 5;

/** Golden base R$ 3.000,00 — 15% faixa, imposto R$ 68,56. */
export const IRPF_GOLDEN_BASE_3000 = 3000;

export const IRPF_GOLDEN_IMPOSTO_3000 = 68.56;
